// extracted by mini-css-extract-plugin
module.exports = {"container":"splashscreen_container__2Gwb0","textAnimate":"splashscreen_textAnimate__1t59d"};